import { KisiModel } from '../user/kisi.model';

/**
 * Rol simülasyonu tipi. Backend AppEnums.SIMULASYON_TIP ile birebir aynı.
 */
export enum SIMULASYON_TIP {
  Yok = 0,
  /** Kendi kullanıcınla, seçtiğin rollerin yetkileriyle gez. */
  Rol = 1,
  /** Seçtiğin kullanıcının kimliğine bürün (o kişinin rolleri + firma bağlantısı). */
  Kullanici = 2,
}

/** Rol seçim listesi. Rol id'leri sistemde açık taşınıyor, bu yüzden BaseModel değil. */
export class SimuleEdilebilirRolModel {
  rolId: number;
  rolAd: string;
  /** Firma rolleri t_firma_kullanici bağlantısına da bakar; arayüzde uyarı gösterilir. */
  isFirmaRolu: boolean;
}

export class RolSimulasyonBaslatRequestModel {
  simulasyonTip: number;
  /** Tip = Rol iken zorunlu. */
  rolIdList: number[] = [];
  /** Tip = Kullanici iken zorunlu. Kullanıcı id'si EID ile taşındığı için DTO olarak gönderilir. */
  hedefKullaniciDto: KisiModel | null = null;
}

/**
 * Simülasyon BAŞLATILMADAN yapılan uygunluk kontrolünün sonucu.
 * Backend: Security/RolSimulasyon/Uygunluk (yan etkisiz, token açmaz).
 */
export class RolSimulasyonUygunlukModel {
  uygunMu: boolean = false;
  sebep: string = '';
  acilabilirSayfaLinkList: string[] = [];
  menuSayisi: number = 0;
  etkinRolIdList: number[] = [];
}

export class RolSimulasyonDurumModel {
  isSimulasyon: boolean = false;
  simulasyonTip: number;
  simulasyonAciklama: string;
  simulasyonBaslatanLoginName: string;
  simulasyonRolIdList: number[];
}
